import { reactive } from "vue"

type Variant = "default" | "destructive"

interface DialogState {
  open: boolean
  title: string
  description: string
  confirmLabel: string
  cancelLabel: string
  variant: Variant
  resolve: ((value: boolean) => void) | null
}

// Singleton — one shared state across all callers
const state = reactive<DialogState>({
  open: false,
  title: "",
  description: "",
  confirmLabel: "Confirm",
  cancelLabel: "Cancel",
  variant: "default",
  resolve: null,
})

function closeWith(value: boolean) {
  state.open = false
  state.resolve?.(value)
  state.resolve = null
}

export interface ConfirmOptions {
  title: string
  description?: string
  confirmLabel?: string
  cancelLabel?: string
  variant?: Variant
}

function confirm(options: ConfirmOptions): Promise<boolean> {
  return new Promise((resolve) => {
    state.title = options.title
    state.description = options.description ?? ""
    state.confirmLabel = options.confirmLabel ?? "Confirm"
    state.cancelLabel = options.cancelLabel ?? "Cancel"
    state.variant = options.variant ?? "destructive"
    state.open = true
    state.resolve = resolve
  })
}

export function useDialog() {
  return { state, confirm, closeWith }
}
